export const getUpdatedPayload = (intent) => {
    const payload = intent.extensions.body?.payload;
    return typeof payload === "string"
      ? payload.replace(/:\s*(\$\.\w+(\.\w+)*\b)/g, ': "$1"')
      : payload;
  };